

var urls = {
    api: __API_ROOT__,
    event: __EVENT_ROOT__
}

export const __urls__ = urls;
 
export const config = {
    urls
} 


// WEBPACK FOOTER //
// ./src/config.client.ts